// Module
var code = "<div data-bind=\"scrollFixer: {}\" class=\"iframe-container\"> <iframe data-bind=\"attr: { src: $data.FormatUrl() }\" class=\"iframe-element\" height=\"100%\"></iframe> </div>";
// Exports
export default code;